<template>
  <aside>
    <modal
      :name="name"
      :adaptive="true"
      height="auto"
      :clickToClose="clickToClose"
      ref="modalTemplate"
      :class="name"
      @opened="openEvents"
      @before-close="closeEvents"
      @closed="closeEvents"
    >
      <div class="modal">
        <div
          class="modal__section modal__header"
          :class="'modal__header--' + name"
        >
          <button @click="hideModal(name)" class="button-close" v-if="clickToClose" aria-describedby="modalClose">
            <img src="/assets/close-x.png" :alt="closeAltText" />
            <p class="sr-only" id="modalClose">{{ closeAltText }}</p>
          </button>
          <slot name="header"></slot>
        </div>
        <div class="modal__section modal__body" :class="'modal__body--' + name">
          <slot name="default"></slot>
        </div>
        <div
          class="modal__section modal__footer"
          :class="'modal__footer--' + name"
        >
          <slot name="footer"></slot>
        </div>
      </div>
    </modal>
  </aside>
</template>

<script>
export default {
  name: "modal-template",
  props: {
    name: {
      type: String,
      required: true,
    },
    clickToClose: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    openEvents() {
      // Disabling while closeEvents doesn't work
      document.body.classList.add("modal-open");
    },
    closeEvents() {
      // this doesn't appear to be firing if we navigate from a modal to another view
      document.body.classList.remove("modal-open");
    },
    hideModal(name) {
      this.$modal.hide(name);
    },
  },
  computed: {
    closeAltText() {
      return this.$t('buttons.close');
    }
  },
  beforeDestroy() {
    this.closeEvents();
  }
};
</script>
